import axios from "axios";
import store from "../store";
import { GET_AUTH_INFORMATION } from "../helpers/vuex-constants";

const axiosInstance = axios.create({});

axiosInstance.interceptors.request.use((config) => {
  let authParams = store.getters[GET_AUTH_INFORMATION];

  if (authParams.wrapCode && authParams.wrapCode.indexOf("Bearer ") != -1) {
    config.headers["Authorization"] = authParams.wrapCode;
  } else {
    config.headers.wrapcode = authParams.wrapCode;
  }
  return config;
});

export default axiosInstance;
